export class UserType {
    id: number;
    username: string;

    public constructor(id: number, username: string){
        this.id = id
        this.username = username
    }
}
